import { lazy } from "react";

// Lazy-loaded view components
const loadEnglish = () => import("../views/English");
export const English = lazy(loadEnglish);
const loadListPodcastView = () => import("../views/ListPodcastView");
export const ListPodcastView = lazy(loadListPodcastView);
const loadTopListPodcastView = () => import("../views/TopListPodcastView");
export const TopListPodcastView = lazy(loadTopListPodcastView);
const loadFindView = () => import("../views/FindView");
export const FindView = lazy(loadFindView);
const loadPolicyView = () => import("../views/PolicyView");
export const PolicyView = lazy(loadPolicyView);
const loadAboutView = () => import("../views/AboutView");
export const AboutView = lazy(loadAboutView);
const loadSubjectListView = () => import("../views/SubjectListView");
export const SubjectListView = lazy(loadSubjectListView);
const loadSubjectView = () => import("../views/SubjectView");
export const SubjectView = lazy(loadSubjectView);
const loadPodcastView = () => import("../views/PodcastView");
export const PodcastView = lazy(loadPodcastView);
const loadEpisodeView = () => import("../views/EpisodeView");
export const EpisodeView = lazy(loadEpisodeView);
const loadPodcastSeasonView = () => import("../views/PodcastSeasonView");
export const PodcastSeasonView = lazy(loadPodcastSeasonView);
const loadAuthorView = () => import("../views/AuthorView");
export const AuthorView = lazy(loadAuthorView);
const loadCollectionView = () => import("../views/CollectionView");
export const CollectionView = lazy(loadCollectionView);
const loadCollectionList = () => import("../views/CollectionList");
export const CollectionList = lazy(loadCollectionList);
const loadCategories = () => import("../views/Categories");
export const Categories = lazy(loadCategories);
const loadCategory = () => import("../views/Category");
export const Category = lazy(loadCategory);
const loadAccountView = () => import("../views/AccountView");
export const AccountView = lazy(loadAccountView);
const loadAdminView = () => import("../views/AdminView");
export const AdminView = lazy(loadAdminView);

/** Which code a path needs, for the links that start loading it on hover or focus. Most specific first. */
const routeLoaders: Array<[RegExp, () => Promise<unknown>]> = [
    [/^\/podd\/[^/]+\/season\/[^/]+$/, loadPodcastSeasonView],
    [/^\/podd\/[^/]+\/[^/]+$/, loadEpisodeView],
    [/^\/podd\/[^/]+$/, loadPodcastView],
    [/^\/kategori\/[^/]+$/, loadCategory],
    [/^\/upphovsman\/[^/]+$/, loadAuthorView],
    [/^\/samling\/[^/]+$/, loadCollectionView],
    [/^\/fokus\/[^/]+$/, loadSubjectView],
    [/^\/topplista(\/[^/]+)?$/, loadTopListPodcastView],
    [/^\/poddar$/, loadListPodcastView],
    [/^\/hitta$/, loadFindView],
    [/^\/om$/, loadAboutView],
    [/^\/policy$/, loadPolicyView],
    [/^\/en$/, loadEnglish],
    [/^\/konto(\/.*)?$/, loadAccountView],
];

/** The loader for a path's page, or undefined for a path with no page of its own (or a page not split out) */
export const loaderFor = (path: string) => {
    const pathname = path.split(/[?#]/)[0];
    return routeLoaders.find(([pattern]) => pattern.test(pathname))?.[1];
};

/** Starts downloading the code for a path's page, e.g. when a link to it is hovered. A failure is left for the page. */
export const preloadRoute = (path: string) => {
    loaderFor(path)?.()?.catch(() => undefined);
};
